import { Component, OnInit } from '@angular/core';
import { GbgrundstueckService } from '../../../core/gb-api';
import { ActivatedRoute, Router } from '@angular/router';
import { TimepointService } from '../../../core/services/timepoint.service';
import { AppConfigService } from '../../../core/services/app-config.service';
import { AbstractGrundstueckEntryFromRoute } from '../abstract-grundstueck-entry-from.route';
import { RubrikComponent } from '../../../shared/components/rubrik/rubrik.component';
import { NgClass } from '@angular/common';
import { GrundstueckHaengigeComponent } from '../../haengige/grundstueck-haengige.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-haengige-rubrik',
  templateUrl: './grundstueck-haengige-rubrik.component.html',
  styleUrls: ['./grundstueck-haengige-rubrik.component.scss'],
  imports: [RubrikComponent, NgClass, GrundstueckHaengigeComponent, TranslatePipe]
})
export class GrundstueckHaengigeRubrikComponent extends AbstractGrundstueckEntryFromRoute implements OnInit {
  public loadOption: 'ALLE' | 'HAENGIGE' = 'HAENGIGE';

  constructor(
    protected route: ActivatedRoute,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService,
    protected router: Router
  ) {
    super(route, grundstueckService, timepointService, appConfigService, router);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  setLoadOptions(option: 'ALLE' | 'HAENGIGE' = 'HAENGIGE') {
    this.loadOption = option;
  }

  protected loadData() {}
}
